import { ActCycleConfig } from '../types';

export const config: Partial<ActCycleConfig> = {
  /** 三语文案 */
  startContent: {
    'zh-cn': '活动未开始，请到「优惠专区」关注其他优惠活动',
    'zh-hk': '活動未開始，請到「優惠專區」關注其他優惠活動',
    en: 'The event has not yet started, please go to the "Promotion Zone" to follow other promotions',
  },
  /** 三语文案 */
  startBtn: {
    'zh-cn': '立即前往',
    'zh-hk': '立即前往',
    en: 'go now',
    /** 链接地址，填写则会进行跳转 */
    linkAdress: 'https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml',
  },
  /** 三语文案 */
  endContent: {
    'zh-cn': '活动已结束，请到「优惠专区」关注其他优惠活动',
    'zh-hk': '活動已結束，請到「優惠專區」關注其他優惠活動',
    en: 'The event has ended, please go to the "Promotion Zone" to follow other promotions',
  },
  /** 三语文案 */
  endBtn: {
    'zh-cn': '立即前往',
    'zh-hk': '立即前往',
    en: 'go now',
    /** 链接地址，填写则会进行跳转 */
    linkAdress: 'https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml',
  },
  /** 是否展示开始活动弹窗 */
  isShowStartDialog: false,
  /** 是否展示结束活动弹窗 */
  isShowEndDialog: true,
};
